import {
	MimaButton,
	MimaText,
	Modal,
} from '../../components';

const DeleteFaqCategory = ({ closeModal, data, handleDelete, loading, goBack }) => {

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitleBold" align="center" mb={3}>
				Delete FAQ Category
			</MimaText>

      <MimaText mb={2} align="center">
        Are you sure you want to delete <br></br><span style={{ fontWeight: '700', color: 'var(--color-primary)' }}>{data.name}</span>
      </MimaText>

      <div className='modal__beside'>
        <MimaButton
          title={'Yes'}
          width={18}
          onClick={() => {
            handleDelete()
          }}
          loading={loading}
        />

        <MimaButton
          title={'Cancel'}
          width={18}
          buttonColor={'grey'}
          onClick={() => closeModal()}
        />
      </div>
		</Modal>
	);
};

export default DeleteFaqCategory;